/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AggregatesListingCardMeQueryVariables = {||};
export type AggregatesListingCardMeQueryResponse = {|
  +me: ?{|
    +__typename: string
  |}
|};
export type AggregatesListingCardMeQuery = {|
  variables: AggregatesListingCardMeQueryVariables,
  response: AggregatesListingCardMeQueryResponse,
|};
*/


/*
query AggregatesListingCardMeQuery {
  me {
    __typename
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingCardMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AggregatesListingCardMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "168be1d4dbf1dffd13fea507faf8f564",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingCardMeQuery",
    "operationKind": "query",
    "text": "query AggregatesListingCardMeQuery {\n  me {\n    __typename\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3105906e5dd01a6968dae6de681d9573';

export default node;
